export const VOICE_MODE = {
  settleMs: 700,
  quietMs: 800,
  progressHoldS: 5,
  exchangeSettleMs: 2500,
  transcriptFlushS: 2,
  idleCloseS: 120,
  closeTimeoutMs: 15000,
  iceTimeoutMs: 10000,
  startTimeoutMs: 15000,
  cleanCadenceMs: 1000,
  cleanWaitMs: 3000,
  lateWordsMs: 1500,
  handOffQuietMs: 2000,
  handOffMaxHoldMs: 4000,
};

export const VOICE_NOTES = {
  failed: "Something went wrong with that request. Please try again.",
  busy: "I'm still working on your current request, so I haven't changed anything or started anything new. I'll come back to this once the results are in.",
  stopped: "The user pressed Stop, so the current request was cancelled. Nothing more will come from it.",
  nothingHeard: "Nothing was heard from the user for this request, so nothing was sent.",
  typed: (text: string) =>
    `The user typed a message in the chat instead of speaking: "${text}". The reply is on screen and was not spoken.`,
  chip: (text: string) =>
    `The user tapped the suggestion "${text}" in the chat instead of saying it. That is their next request; the answer is on its way.`,
  heard: (text: string) =>
    `While the last request was being worked on, the user also said: "${text}". None of that has been acted on yet. Now respond to it: answer any question that needs no new search, and if it needs a new search or asks for a change, ask the user whether to start one or update the request.`,
  lateWords: (text: string) =>
    `The last request went out before the user finished speaking, without the user's final words: "${text}". If these words change or add to what was asked, check with the user before starting anything new. Otherwise leave them unmentioned.`,
  progress: (text: string) =>
    `New from the search: "${text}". Tell the user in one short sentence what is happening, with their details where they fit. Never say "on it" or "still", and never mention waiting.`,
  opening: (screen: string) =>
    `The user has just turned on voice and has not said anything yet. On their screen: ${screen}. Open the conversation now as your opening policy says, then listen.`,
};

export const VOICE_SCREENS = {
  plan: (destination: string) => `a trip plan for ${destination}`,
  emptyChat: "an empty chat",
  tripIdeas: "trip ideas",
  flightResults: "flight results",
  hotelResults: "hotel results",
  earlier: "an earlier conversation",
};

export const VOICE_TOASTS = {
  ended: "Voice ended",
  restart: "Tap the voice button to continue.",
  micBlocked: "Microphone blocked",
  micHelp: "Allow microphone access to use voice.",
  unavailable: "Voice unavailable",
  tryAgain: "Voice could not start. Please try again.",
};

export const VOICE_BAR = {
  userLoudLevel: 0.09,
  zoyaLoudLevel: 0.02,
  speakerMinMs: 90,
  speakerHoldMs: 350,
  brandAfterMs: 900,
  revealMs: 700,
  minContrast: 2.4,
  fallbackRgb: [170, 170, 170] as [number, number, number],
  ribbons: [
    { frequency: 1.7, speed: 0.0021, scale: 1, shade: 0, alpha: 0.55, bands: [0, 0.3] as [number, number] },
    { frequency: 2.6, speed: -0.0016, scale: 0.8, shade: 1, alpha: 0.5, bands: [0.25, 0.6] as [number, number] },
    { frequency: 3.4, speed: 0.0027, scale: 0.62, shade: 2, alpha: 0.42, bands: [0.55, 1] as [number, number] },
  ],
};

export const VOICE_PLACEHOLDERS = {
  connecting: "Connecting voice...",
};
